var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverItemIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3335V26.3338C5 28.2007 5 29.1336 5.36331 29.8466C5.68289 30.4738 6.19245 30.9843 6.81966 31.3039C7.532 31.6668 8.46499 31.6668 10.3282 31.6668H29.6718C31.535 31.6668 32.4667 31.6668 33.179 31.3039C33.8062 30.9843 34.3175 30.4738 34.637 29.8466C35 29.1343 35 28.2027 35 26.3395V18.3335M5 18.3335V15.0002M5 18.3335H35M5 15.0002V13.6672C5 11.8003 5 10.8662 5.36331 10.1532C5.68289 9.52595 6.19245 9.01639 6.81966 8.69681C7.5327 8.3335 8.46682 8.3335 10.3337 8.3335H29.667C31.5338 8.3335 32.466 8.3335 33.179 8.69681C33.8062 9.01639 34.3175 9.52595 34.637 10.1532C35 10.8655 35 11.7985 35 13.6617V15.0002M5 15.0002H35M11.6667 25.0002H18.3333M35 18.3335V15.0002",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverItemIcon2);
export default __webpack_public_path__ + "static/media/discoverItemIcon2.4dce625591c045827d21f7107a21363b.svg";
export { ForwardRef as ReactComponent };